import { Component } from '@angular/core';

@Component({
  selector: 'app-scientific-session24',
  templateUrl: './scientific-session24.component.html',
  styleUrl: './scientific-session24.component.css'
})
export class ScientificSession24Component {

}
